import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import RidesSearchForm from './components/RidesSearchForm';
import { validateTicketSearch } from '../../../../../../utils/functions/ticketSearch';
import { useAuth } from '../../../../../contexts/userContext/userContext';
import useTranslation from '../../../../../hooks/translation/useTranslation';

const formWrapperDesktopClasses = 'lg:relative lg:h-[140px] lg:bottom-[69px] lg:mb-[-69px] lg:p-0 lg:w-full lg:left-0';
const formWrapperMobileClasses = 'fixed z-[3] h-[475px] flex-col gap-5 bottom-[70px] pb-3 w-[calc(100%-56px)] left-[28px] duration-300 ease-out';
function SearchTrainTickets() {
  const { user } = useAuth();
  const { currentLanguage, trans } = useTranslation();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    form.setFieldsValue({
      standard_passengers: 1,
      child_passengers: 0,
      disabled_passengers: 0,
    });
  }, [user?.type]);

  return (
    <div
      className={`flex items-center justify-center bg-white rounded-2xl shadow-md box-content drop-shadow-4xl ${formWrapperDesktopClasses} ${formWrapperMobileClasses}`}
      style={{ borderBottom: '8px solid var(--primary-color)' }}
    >
      <RidesSearchForm
        errors={errors}
        style={{ width: 'calc(100% - 70px)' }}
        form={form}
        handleSubmit={(values) => validateTicketSearch({
          values,
          setErrors,
          navigate,
          currentLanguage,
          trans,
        })}
      />
    </div>
  );
}

export default SearchTrainTickets;
